<template>
  <div class="pagination-see-more-component container my-4">
    <div class="d-flex justify-content-center" v-if="isLoading">
      <b-spinner variant="success" style="width: 2rem; height: 2rem;" />
    </div>
    <div v-else-if="count > limit">
      <div class="row justify-content-center">
        <div class="col-lg-3">
          <button
            class="btn btn-block see-more"
            @click="showMore"
            :disabled="btnDisabled"
          >
            <h5 class="m-0">Ver mais [{{ seeMoreNumber }}]</h5>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      limit: this.initLimit,
      btnDisabled: false
    };
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    initLimit: {
      type: Number,
      default: 3
    },
    count: {
      type: Number,
      default: null
    },
    addedValue: {
      type: Number,
      default: 10
    }
  },
  computed: {
    seeMoreNumber() {
      const number = this.count - this.limit;
      if (number < 0) {
        number = 0;
      }
      return number;
    }
  },
  methods: {
    showMore() {
      this.limit += this.addedValue;
      this.$emit("dispatch", { limit: this.limit, loading: true });
    }
  },
  watch: {
    initLimit(newValue) {
      this.limit = newValue;
    }
  }
};
</script>

<style scoped lang="scss">
.pagination-see-more-component {
  .see-more {
    background-color: #2c2c2c;
    color: #fff;
    transition: 0.4s;

    &:hover {
      filter: brightness(80%);
    }
  }
}
</style>
